import React from 'react';
import { useTranslation } from 'react-i18next';
import AddToGroup from '@wix/da-ds/pkg/Icons/AddToGroup';
import { BiDataHook, BiEventType } from '@wix/da-bi/pkg/constants';
import { useCustomNotifications } from '../../../Notifications/CustomNotificationContext';
import { NotificationType } from '../../../Notifications';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarToggleButton from '../../_partials/items/ActionBarToggleButton';
import { FirstTimeFlag } from '../../../redux/firstTimeFlags';
import { useFirstTimeFlag } from '../../../redux/firstTimeFlags/hooks';
import SophisticatedFtueTooltip from '../../../Popover/Preset/SophisticatedFtueTooltip';
var addToGroupNotificationType = [NotificationType.AddToGroup];
export var AddToGroupButton = function (_a) {
    var activated = _a.activated, withTooltip = _a.withTooltip, deviation = _a.deviation, onClick = _a.onClick;
    var t = useTranslation().t;
    // a ftue tooltip appears the first time a user submits a deviation
    // that suggests adding the deviation to a group
    var hasAddToGroupFtue = useFirstTimeFlag(FirstTimeFlag.IsDevpageAddToGroupNotShown).hasFlag;
    var currentUrl = typeof window !== 'undefined' ? new URL(window.location.href) : undefined;
    var hasNewSubmissionUrlParam = !!(currentUrl === null || currentUrl === void 0 ? void 0 : currentUrl.searchParams.get('ga_submit_new'));
    var showingFtueTooltip = hasAddToGroupFtue && hasNewSubmissionUrlParam;
    // otherwise, addToGroup notificiations or the simple tooltip is shown
    var notifications = useCustomNotifications(addToGroupNotificationType).notifications;
    var isShowingTooltip = withTooltip && !notifications.length;
    var tooltipText = isShowingTooltip ? t('actionbar.addToGroup') : undefined;
    var button = (React.createElement(ActionBarToggleButton, { activated: activated, onClick: onClick, "data-hook": BiDataHook.DEVIATION_GROUPS_COUNTER, biData: {
            evid: BiEventType.ADD_TO_GROUP_CLICK,
            deviationid: deviation.deviationId,
            sectionname: 'add_to_group',
        }, icon: AddToGroup }));
    return showingFtueTooltip ? (React.createElement(SophisticatedFtueTooltip, { flag: FirstTimeFlag.IsDevpageAddToGroupNotShown, size: "medium", placement: "top", width: 290, hasCloseButton: true, prefix: React.createElement("img", { loading: "lazy", alt: "IL44", src: "https://st.deviantart.net/eclipse/promos/il4-5.svg" }), heading: t('deviationview.groupPrompt.title'), description: t('deviationview.groupPrompt.message') }, button)) : (React.createElement(ActionBarItemWrapper, { tooltip: tooltipText, notificationTypes: addToGroupNotificationType }, button));
};
AddToGroupButton.displayName = 'AddToGroupButton';
export default AddToGroupButton;
//# sourceMappingURL=AddToGroupButton.js.map